import _ from "lodash";
import axios from "axios";
import sign from "../../utils/sign";
import { loginByPassportSDK } from "./passport";
import { removeAllCookie } from "@/utils/cookie";
import { Toast } from "mand-mobile";
const http = axios.create({
  timeout: 10 * 1000,
  withCredentials: true,
});

const headers = {
  jTicket: ''
};

const statusMap = {
  SUCCESS: 0, //成功
  NOT_LOGIN: 2,
};

http.interceptors.request.use((req) => {
  const contentType = req.headers["Content-Type"] || "application/json";
  const { url, params, data } = req

  req.headers = {
    ...req.headers,
    ...headers,
    wsgsig: sign.getWsgsigSign(url, params, data, contentType)
  };

  return req;
});

// 拦截未登录的情况
http.interceptors.response.use(async (res) => {
  removeAllCookie(); // 以防cookie里面带上jTicket，导致未登录的情况
  const { status } = res.data;
  if (status === statusMap.NOT_LOGIN) {
    Toast.hide();
    const jTicket = await loginByPassportSDK();
    headers.jTicket = jTicket;
  }

  return res;
});

export default http;
